<template>
  <section class="grid">
    <TotalAppointmentsCard />
    <AppointmentStatusSummary />
    <TopServicesList />
    <AppointmentsPerExpertBar />
    <DailyCompletedLineChart />
  </section>
</template>

<script>
import TotalAppointmentsCard      from './TotalAppointmentsCard.vue';
import AppointmentStatusSummary   from './AppointmentStatusSummary.vue';
import TopServicesList            from './TopServicesList.vue';
import AppointmentsPerExpertBar   from './AppointmentsPerExpertBar.vue';
import DailyCompletedLineChart    from './DailyCompletedLineChart.vue';

export default { components: {
  TotalAppointmentsCard,
  AppointmentStatusSummary,
  TopServicesList,
  AppointmentsPerExpertBar,
  DailyCompletedLineChart
}};
</script>
